import { Component, Input, OnInit } from '@angular/core';
import { ValueType } from '@app/models/enums/value-type.enum';
import { IncentiveDetail } from '@app/models/incentive/incentive-detail';
import { IncentiveDictKey } from '@app/models/incentive/incentive-dict-key.enum';
import { IncentiveRule } from '@app/models/incentive/incentive-rule';
import { IncentiveRuleKey } from '@app/models/incentive/incentive-rule-key.enum';
import { BaseComponent } from '@core/component/base/base.component';
import { I18nService } from '@core/services/i18n/i18n.service';
import { AuthService } from '@services/auth.service';
import { toString } from 'lodash';

// import { QRCodeElementType, QRCodeErrorCorrectionLevel } from 'angularx-qrcode/lib/types';

import { QRCodeComponent, QRCodeElementType, QRCodeErrorCorrectionLevel } from 'angularx-qrcode';

import { CommonModule } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
@Component({
  standalone: true,
  selector: 'app-incentive-view',

  imports: [QRCodeComponent, CommonModule, NzTableModule, NzTabsModule, NzToolTipModule],
  templateUrl: './incentive-view.component.html',
  styleUrls: ['./incentive-view.component.less'],
})
export class IncentiveViewComponent extends BaseComponent implements OnInit {
  @Input() incentiveDetail!: IncentiveDetail;
  @Input() qrUrl = '';
  @Input() isMobile = false;

  // QRCodeElementType与QRCodeErrorCorrectionLevel在新版本下是type类型，不能用于赋值
  elementType: QRCodeElementType = 'url';
  correctionLevel: QRCodeErrorCorrectionLevel = 'M';

  get currRule(): IncentiveRule {
    return this.incentiveDetail?.rule || ({} as IncentiveRule);
  }

  get currRuleTitle(): string {
    return toString(this.incentiveDetail?.incentiveInfo?.TITLE?.value || this.currRule.ruleName[this.currLang]);
  }

  get info() {
    return this.incentiveDetail?.incentiveInfo;
  }

  get prodInfo(): string {
    return toString(this.info?.PRODUCT_DETAIL?.value).replace(/\|\|/g, '\t');
  }
  get calcKpis() {
    let kpis: IncentiveDictKey[] = [];
    switch (this.currRule.ruleKey) {
      case IncentiveRuleKey.TSI_SALES:
        kpis = [IncentiveDictKey.CURRENT_SALES, IncentiveDictKey.UNIT_PRICE];
        break;
      case IncentiveRuleKey.TSI_LIVE_STREAM:
        kpis = [IncentiveDictKey.CURRENT_SALES, IncentiveDictKey.SHARE_OF_LIVESTREAM_SKU, IncentiveDictKey.SALES_OF_LIVESTREAM_SKU];
        break;
      case IncentiveRuleKey.TSI_DISCOUNT:
        kpis = [IncentiveDictKey.CURRENT_SALES, IncentiveDictKey.SALES_AFTER_DISCOUNT, IncentiveDictKey.DISCOUNT_RATE];
        break;
      case IncentiveRuleKey.TSI_UNIT_PRICE:
        kpis = [IncentiveDictKey.CURRENT_SALES, IncentiveDictKey.UNIT_PRICE, IncentiveDictKey.UNIT_PRICE_BY_SEGMENT];
        break;
    }
    return kpis;
  }

  get ictRuleKey(): typeof IncentiveRuleKey {
    return IncentiveRuleKey;
  }

  get valueType(): typeof ValueType {
    return ValueType;
  }

  itemLinkClick(itemLink: string) {
    if (this.isMobile) return;
    window.open(itemLink, '_blank');
  }

  constructor(i18nService: I18nService, authService: AuthService) {
    super(authService, i18nService);
  }

  ngOnInit(): void {}
}
